import "./styles/LoadingIcon.css";

export default function LoadingIcon() {
  return <svg className="loading-icon-border-color animate-spin rounded-full border-9 h-16 w-16"></svg>;
}
